module Dashboard {
    export function Init(dates: any): void {
        PlsWait.ShowLoader(false);
        var dateFrom = dates.split("$")[0];
        var dateTo = dates.split("$")[1];

        $('#dateFrom').datepicker({
            format: 'dd.mm.yyyy',
            autoclose: true,
            todayBtn: true,
            todayHighlight: true
        });

        $('#dateFrom').datepicker('update', Common.FormatDate(dateFrom, 'eu'));

        $('#dateTo').datepicker({
            format: 'dd.mm.yyyy',
            autoclose: true,
            startDate: $('#dateFrom').val().toString(),
            todayBtn: true,
            todayHighlight: true
        });

        $('#dateTo').datepicker('update', Common.FormatDate(dateTo, 'eu'));

        $('#versionList').change(function () {
            pageReload();
        });

        $('#companyList').change(function () {
            pageReload();
        });

        $("#setDates").on("click", function () {
            pageReload();
        });

        $("#dateFrom").on("change", function (e) {
            var dateFrom: Date = new Date(Common.FormatDate($('#dateFrom').val().toString(), "js"));
            var dateTo: Date = new Date(Common.FormatDate($('#dateTo').val().toString(), "js"));
            if (dateFrom >= dateTo) {
                $('#dateTo').datepicker('update', $('#dateFrom').val().toString());
            }
            $('#dateTo').datepicker('setStartDate', dateFrom);
        });

        var scrDashboardColDef: DataTables.ColumnDefsSettings[] = [
            {
                targets: 0,
                createdCell: function (td, cellData, rowData, row, col) {
                    $(td).css('text-align', 'left');
                }
            },
            {
                targets: [3, 4, 5, 6],
                orderable: false
            }
        ];

        Common.DataTableCustom.Init(
            'scrDashboardTable',
            {
                pageLength: 15,
                lengthChange: false,
                searching: false
            },
            scrDashboardColDef
        );

        var scriptDataColDef: DataTables.ColumnDefsSettings[] = [
            {
                targets: 0,
                createdCell: function (td, cellData, rowData, row, col) {
                    $(td).css('text-align', 'left');
                }
            },
            {
                targets: [7, 8, 9, 10],
                visible: false
            },
            { targets: 1, orderData: 7 },
            { targets: 2, orderData: 8 },
            { targets: 3, orderData: 9 },
            { targets: 4, orderData: 10 }
        ];

        Common.DataTableCustom.Init(
            'scriptDataTable',
            {
                scrollY: '55vh',
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, 'All']]
            },
            scriptDataColDef
        );

        $('#scrDashboardTable').on('click', '.dsh-script-details', function () {
            var scriptId = $(this).data("id-script");
            Dialog.OpenDetailsModal('Detalji skripte', '/Script/Details/' + scriptId);
        });
    }

    function pageReload(): void {
        PlsWait.ShowLoader(true);
        var date_from: string = Common.FormatDate($('#dateFrom').val().toString(), 'en');
        var date_to: string = Common.FormatDate($('#dateTo').val().toString(), 'en');
        var version_id: string = $("#versionList").val().toString();
        var id_company: string = $("#companyList").val().toString();

        var ajaxParams: JQueryAjaxSettings = {};
        ajaxParams.url = '/Dashboard/ReloadPage/' + date_from + '/' + date_to + '/' + version_id + '/' + id_company;
        ajaxParams.type = 'POST';
        ajaxParams.contentType = 'application/json';
        ajaxParams.traditional = true;
        ajaxParams.success = () => {
            location.reload();
        };
        ajaxParams.error = (err) => {
            Notifications.GetNotification(err.statusText, "danger");
            PlsWait.ShowLoader(false);
        };

        $.ajax(ajaxParams);
    }
}

module DshCharts {
    var _charts: any[] = [];
    var _resizeTimer: any;
    var _lastBarList: any = null;
    var _lastPieList: any = null;

    export function initCharts(barList: any, pieList: any): void {
        _lastBarList = barList;
        _lastPieList = pieList;
        _charts.forEach(function (c) { try { c.destroy(); } catch (e) {} });
        _charts = [];

        $('*[data-myval="charPieToShow"]').each(function () {
            var elementId: string = $(this).attr("id");
            initPieChart(elementId, pieList);
        });

        $('*[data-myval="charBarToShow"]').each(function () {
            var elementId: string = $(this).attr("id");
            initBarChart(elementId, barList);
        });

        $(window).off('resize.dshCharts').on('resize.dshCharts', function () {
            clearTimeout(_resizeTimer);
            _resizeTimer = setTimeout(function () {
                _charts.forEach(function (c) { c.resize(); });
            }, 100);
        });

        document.removeEventListener('skr-theme-changed', _onThemeChanged as EventListener);
        document.addEventListener('skr-theme-changed', _onThemeChanged as EventListener);
    }

    function _onThemeChanged() {
        if (_lastBarList !== null && _lastPieList !== null) {
            initCharts(_lastBarList, _lastPieList);
        }
    }

    function initPieChart(elementId: string, pieList: any): void {
        var enviroment: string = elementId.split('_')[0];
        var customerId: string = elementId.split('_')[1];
        const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
        const labelColor = isDark ? 'white' : '#666';

        for (var i = 0; i < pieList.length; i++) {
            if (pieList[i].id_company == customerId && pieList[i].enviroment.toUpperCase() == enviroment.toUpperCase()) {
                var perc_rel: number = pieList[i].perc_rel;
                var perc: number = pieList[i].perc;

                var data = [perc_rel, perc];

                var myDoughnutChart = new Chart(elementId, {
                    type: 'doughnut',
                    data: {
                        labels: ["Pušteno", "Nije pušteno"],
                        datasets: [{
                            backgroundColor: ["#13B9CE", "#EA4541"],
                            borderColor: ["#117888", "#ad1f2d"],
                            borderWidth: 1,
                            data: data
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        title: {
                            display: true,
                            text: 'Postotak puštanja skripti',
                            fontColor: labelColor
                        },
                        legend: {
                            display: true,
                            position: "top",
                            labels: {
                                boxWidth: 18,
                                fontSize: 12,
                                fontColor: labelColor
                            }
                        },
                        animation: {
                            animateRotate: true,
                            animateScale: true,
                            duration: 4000
                        },
                        cutoutPercentage: 50
                    }
                });
                _charts.push(myDoughnutChart);
            }
        }
    }

    function initBarChart(elementId: string, barList: any) {
        var customerId: string = elementId.split('_')[1];

        var arrDates = new Array();
        var arrFat = new Array();
        var arrUat = new Array();
        var arrProd = new Array();
        var arrAllScripts = new Array();

        for (var i = 0; i < barList.length; i++) {
            if (barList[i].id_company == customerId) {
                arrDates.push(barList[i].create_date);
                arrFat.push(barList[i].br_fat);
                arrUat.push(barList[i].br_uat);
                arrProd.push(barList[i].br_prod);
                arrAllScripts.push(barList[i].all_scripts);
            }
        }

        var myData = {
            labels: arrDates,
            datasets: [
                {
                    label: "Fat",
                    backgroundColor: "#13B9CE",
                    borderColor: "#117888",
                    borderWidth: 2,
                    data: arrFat
                },
                {
                    label: "Uat",
                    backgroundColor: "#FD970F",
                    borderColor: "#cc9900",
                    borderWidth: 2,
                    data: arrUat
                },
                {
                    label: "Prod",
                    backgroundColor: "#EA4541",
                    borderColor: "#ad1f2d",
                    borderWidth: 2,
                    data: arrProd
                },
                {
                    label: 'Ukupno',
                    backgroundColor: document.documentElement.getAttribute('data-theme') === 'dark' ? 'rgba(150,160,180,0.25)' : '#DCDCDC',
                    borderColor: document.documentElement.getAttribute('data-theme') === 'dark' ? 'rgba(150,160,180,0.55)' : '#808080',
                    borderWidth: 2,
                    data: arrAllScripts,
                    type: 'line'
                }]
        };

        const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
        const tickColor = isDark ? 'white' : '#666';
        const gridColor = isDark ? 'rgba(255,255,255,0.15)' : 'rgba(255,99,132,0.2)';

        var option = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                labels: { fontColor: tickColor }
            },
            scales: {
                yAxes: [{
                    ticks: {
                        min: 0,
                        fontColor: tickColor
                    },
                    stacked: false,
                    gridLines: {
                        display: true,
                        color: gridColor
                    }
                }],
                xAxes: [{
                    ticks: { fontColor: tickColor },
                    gridLines: {
                        display: false
                    }
                }]
            },
            animation: {
                duration: 3000
            }
        };

        var myBarChart = new Chart(elementId, {
            type: 'bar',
            data: myData,
            options: option
        });
        _charts.push(myBarChart);
    }
}